/**
 * V2批量打印任务轮询器，负责创建任务并等待终态。
 */
const TERMINAL_STATUSES = new Set(['SUCCEEDED', 'FAILED'])

function nowMs() {
  return typeof performance !== 'undefined' && performance.now
    ? performance.now()
    : Date.now()
}

function elapsedMs(startedAt) {
  return Math.round((nowMs() - startedAt) * 100) / 100
}

function logTiming(task, {
  printId,
  createDurationMs,
  pollingDurationMs,
  totalDurationMs,
  queryCount,
  lastQueryDurationMs
}) {
  console.info('[PrintTaskV2] performance', {
    printId,
    status: task.status,
    totalUnits: task.totalUnits,
    finishedUnits: task.finishedUnits,
    createDurationMs,
    pollingDurationMs,
    queryCount,
    lastQueryDurationMs,
    totalDurationMs,
    totalDurationSeconds: Math.round(totalDurationMs / 10) / 100
  })
}

export class PrintTaskPoller {
  constructor({
    createPrintTask,
    getPrintTask,
    sleep = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds))
  } = {}) {
    this.createPrintTask = createPrintTask
    this.getPrintTask = getPrintTask
    this.sleep = sleep
  }

  async run(request, {
    timeoutMs = 5 * 60 * 1000,
    intervalMs = 1000,
    maxConsecutiveErrors = 3,
    onProgress
  } = {}) {
    const createStartedAt = nowMs()
    const created = await this.createPrintTask(request)
    const createDurationMs = elapsedMs(createStartedAt)
    let task = created && created.data ? created.data : created
    const printId = task && task.printId ? task.printId : ''
    let consecutiveErrors = 0
    const startedAt = Date.now()
    const pollingStartedAt = nowMs()
    const queryDurationsMs = []

    if (task && TERMINAL_STATUSES.has(task.status)) {
      const queryStartedAt = nowMs()
      const response = await this.getPrintTask(task.printId)
      queryDurationsMs.push(elapsedMs(queryStartedAt))
      task = response && response.data ? response.data : response
    }

    while (task && !TERMINAL_STATUSES.has(task.status)) {
      if (Date.now() - startedAt >= timeoutMs) {
        const error = new Error('Print task timeout')
        error.printTask = task
        throw error
      }
      await this.sleep(this.nextDelay(intervalMs, task.pollIntervalMs))
      let queryStartedAt
      try {
        queryStartedAt = nowMs()
        const response = await this.getPrintTask(task.printId)
        queryDurationsMs.push(elapsedMs(queryStartedAt))
        task = response && response.data ? response.data : response
        consecutiveErrors = 0
        if (onProgress) onProgress(task)
      } catch (error) {
        queryDurationsMs.push(elapsedMs(queryStartedAt))
        consecutiveErrors += 1
        if (consecutiveErrors >= maxConsecutiveErrors) {
          error.printTask = task
          throw error
        }
      }
    }
    if (!task) {
      throw new Error('Print task response is empty')
    }
    logTiming(task, {
      printId,
      createDurationMs,
      pollingDurationMs: elapsedMs(pollingStartedAt),
      totalDurationMs: elapsedMs(createStartedAt),
      queryCount: queryDurationsMs.length,
      lastQueryDurationMs: queryDurationsMs[queryDurationsMs.length - 1] || 0
    })
    return task
  }

  nextDelay(intervalMs, serverIntervalMs) {
    const base = Math.max(250, Number(serverIntervalMs || intervalMs))
    return base + Math.floor(Math.random() * 200)
  }
}
